export default "__VITE_ASSET__CEvGSqxX__"